export type InjectedVariables = {
  AG_GRID_LICENSE?: string | null;
  ENVIRONMENT: string;
  GOOGLE_ANALYTICS_KEY?: string | null;
  I18N_ASSETS: Record<string, string>;
  SENTRY_DSN: string | null;
};

declare global {
  interface Window {
    _env_: InjectedVariables | undefined;
  }
}

/**
 * Get injected variables with fallback strategy for browser compatibility
 * Handles cases where process.env polyfill might fail (pounjs)
 */
function getInjectedVariables<T extends InjectedVariables>(): T {
  // Fallback
  let env = {} as T;

  if (typeof process !== 'undefined') {
    env = process.env as unknown as T;
  }

  if (typeof window !== 'undefined' && window._env_ != null) {
    env = window._env_ as T;
    window._env_ = undefined;
  }

  return env;
}

export const {
  AG_GRID_LICENSE = null,
  ENVIRONMENT = 'local',
  GOOGLE_ANALYTICS_KEY = null,
  I18N_ASSETS = {},
  SENTRY_DSN = null,
} = getInjectedVariables<InjectedVariables>();

export const LOGIN_PATH = 'login';
